/**
 * Store admin — Product detail route (Commerce, V1.0.1 M2.1).
 */
import { createFileRoute } from "@tanstack/react-router";
import { ProductDetailPage } from "../../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/products/$listingId/")({
  component: DetailRoute,
});

function DetailRoute() {
  const { listingId } = Route.useParams();
  return <ProductDetailPage listingId={listingId} />;
}
